/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { Button, CloseBtn } from '@styles/button.style'
import { observer } from 'mobx-react'
import { Content, ModalBg } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { Theme } from '@themes/theme'
import Mission from '@views/Mission'

const MissionPopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleMissionListPopup } = globalStore

  const onCloseHandler = () => {
    globalStore.setVisibleMissionListPopup(false)
  }

  const modalClassName = 'full-modal message'
  const contentCss = (theme: Theme) => css`height: 100%; overflow: auto; text-align: left;`
  return (
    <Fragment>
      <Modal
        popup
        visible={visibleMissionListPopup}
        animated={false}
        title={
          <Fragment>
            <h1 className="title">미션</h1>
            <Button onClick={onCloseHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className={modalClassName}
        onClose={onCloseHandler}
        maskClosable={false}
      >
        <Content css={contentCss}>
          <Mission />
        </Content>

        <ModalBg onClick={onCloseHandler} />
      </Modal>
    </Fragment>
  )
}

// 더이상 사용하지 않는 풀팝업
export default observer(MissionPopup)
